<template>
  <a-drawer
    title="新建"
    width="500"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="handleCancel"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 表单项 -->
      <a-form-item
        label="名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.name" placeholder="请输入" />
      </a-form-item>
      <!-- 表单项 -->
      <a-form-item
        label="顺序"
        name="sort"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.sort" placeholder="请输入" />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleOk">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Loading from '@/components/Loading'
import { message } from 'ant-design-vue'
import { allClassifyAdd } from '@/api/admin'

// 注册父组件的事件
const emit = defineEmits('success')
const props = defineProps({
  source: String
})
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// id
let id = ref(undefined)
// 表单数据
let formState = reactive({
  name: undefined,
  sort: undefined
})
// 加载
let isLoading = ref(false)

// 展示弹窗
function showDrawer (data) {
  visible.value = true
  // 记录
  if (!!data) {
    id.value = data.id
    formState.name = data.name
    formState.sort = data.sord_id
  }
}

// 关闭弹窗
function handleCancel () {
  // 重置表单
  RefForm.value.resetFields()
  visible.value = false
  // 重置
  id.value = undefined
  formState.name = undefined
  formState.sort = undefined
}

// 提交
function handleOk () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    allClassifyAdd({
      id: id.value,
      source: props.source,
      name: formState.name,
      sort: formState.sort
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        handleCancel()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>

</style>